export const visit = (vm, at) => {
at({ "en": { "calling-orchestration-shared-library": { "calls-index-page": { "playlist": { "linkText": "Playlists" }, "callAnalytics": { "linkText": "Call Analytics" } } } } });
};